import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontWeights, palette,
}: Theme) => ({
  root: {
    margin: '2rem 0',
    [breakpoints.up('md')]: {
      margin: '3rem 0',
    },
  },
  rootLog: {
    margin: '0.75rem 0',
    [breakpoints.up('md')]: {
      margin: '1.25rem 0',
    },
  },
  container: {
    padding: '1.5rem 1rem',
    borderRadius: '1rem',
    background: palette.common.white,
    boxShadow: '0 4px 8px rgba(4, 67, 92, 0.08)',
    [breakpoints.up('md')]: {
      padding: '2rem',
    },
  },
  title: {
    fontSize: '1.25rem',
    lineHeight: 1.4,
    margin: '0 0 1.5rem',
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      marginBottom: '1rem',
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
  },
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: '1rem',
    columnGap: '1.5rem',
    [breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
      columnGap: '1.5rem',
    },
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.5rem',
    flexBasis: 'calc(50% - 0.75rem)',
    textAlign: 'left',
    [breakpoints.up('md')]: {
      gap: '0.75rem',
      flexBasis: 'calc(25% - 1.125rem)',
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
    '&&': {
      color: palette.text.primary,
      fontSize: '1rem',
      lineHeight: 1.5,
      [breakpoints.up('md')]: {
        fontSize: '1.25rem',
        lineHeight: 1.4,
      },
    },
    '& img': {
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
  },
}));
